<!-- Loading bar -->
<loading-bar></loading-bar>


<!-- Wrapper -->
<div class="flex flex-col flex-auto min-w-0 mt-12 max-w-screen-xl mx-auto">

    <!-- Header -->
    <div class="relative flex gap-6 flex-0 items-center w-full h-16 px-4 md:px-6 z-49 dark:shadow-none  dark:bg-transparent print:hidden">
        
        <!-- Logo -->
        <div class="flex items-end  gap-2">
            <div class="w-12">
                <img src="assets/images/logo/logo.svg">
            </div>
            <h1 class="text-3xl font-extrabold tracking-tight leading-tight text-primary">
                Zeitune <span class="text-secondary"></span>
            </h1>
        </div>

        
        <div class="flex items-center space-x-0.5 sm:space-x-2"></div>
        <!-- Components -->
        <div class="flex items-center ml-auto space-x-2">
            <notifications></notifications>
            <user></user>
        </div>
    </div>

    <!-- Content -->
    <div class="px-4 md:px-6">
        <router-outlet *ngIf="true"></router-outlet>
    </div>
</div>
